"use client";

import { motion } from "framer-motion";
import WhatsAppCTA from "../ui/button";
import { ArrowRight } from "lucide-react";

const Content = () => {
  const container = {
    hidden: {},
    show: {
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const item = {
    hidden: { opacity: 0, y: 40 },
    show: { opacity: 1, y: 0, transition: { duration: 0.6 } },
  };

  return (
    <motion.section
      className="py-10 px-6 bg-muted/20 mt-10 border-t border-gray-200"
      variants={container}
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, amount: 0.2 }}
    >
      <div className="max-w-4xl mx-auto text-center">
        <motion.h3
          className="text-2xl md:text-4xl font-bold text-primary mb-8"
          variants={item}
        >
          Muito mais que experiências:{" "}
          <span className="bg-gradient-to-r from-[hsl(var(--secondary))] to-[hsl(var(--accent))] bg-clip-text text-transparent">
            criamos escapes.
          </span>
        </motion.h3>

        <motion.p
          className="text-base md:text-xl text-muted-foreground leading-relaxed mb-10 max-w-3xl mx-auto text-gray-500"
          variants={item}
        >
          A escapa! nasceu para conectar luxo, turismo e tecnologia, criando
          vivências que inspiram, capacitam e encantam. Nossa missão é
          transformar cada projeto em algo único, misturando conhecimento
          acadêmico, visão de mercado e criatividade sem limites.
        </motion.p>

        <motion.div variants={item}>
          <WhatsAppCTA>
						Agende um reunião!
            <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform duration-300" />
          </WhatsAppCTA>
        </motion.div>
      </div>
    </motion.section>
  );
};

export default Content;
